import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import Input from '@material-ui/core/Input';
import VolumeUp from '@material-ui/icons/VolumeUp';
import Box from '@material-ui/core/Box';
import { BootstrapInput } from './assets/EnergyStyles'

const useStyles = makeStyles({
    root: {
        width: 250,
    },
    input: {
        width: 42,
    },
});

function Blend_slider({fuelOutput:{fuel1,fuel2}}) {
    const classes = useStyles();
    const [value, setValue] = React.useState(30);

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? '' : Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > 100) {
            setValue(100);
        }
    };

    return (
        <div className={classes.root + ' blendrwesultslider'}>
           
            <Grid container spacing={3} alignItems="center" >
                 

                <Grid item xs>
                    <Grid
                        justify="space-between" // Add it here :)
                        container
                        spacing={3}
                    >
                        <Grid item>
                            <Typography id="input-slider" className="blendmisc3" gutterBottom>
                                %Fuel 1
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography id="input-slider" className="blendmisc3"  gutterBottom>
                                %Fuel 2
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid
                        justify="space-between" // Add it here :)
                        container
                        spacing={3}
                        className="blendinput"
                    >
                        <Grid item>
                            <BootstrapInput
                                style={{width: "80px"}}
                                value={Number(fuel1).toFixed(2)}
                            />
                        </Grid>

                        <Grid item>
                            <BootstrapInput
                                style={{width: "80px"}}
                                value={Number(fuel2).toFixed(2)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>

                </Grid>
            </Grid>
        </div>
    );
} export default Blend_slider;